import { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { getTaskLogs } from "../Scrapper/api";
import useAppStore from "../../store/global";
import LogsScreen from "../Scrapper/Logs/LogsScreen";
import Paginator from "../Common/Paginator";
function TaskLogsModal({ show, setShow, id }) {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(false);
  const { pageSize, dateRange, logType } = useAppStore();
  const [pageNum, setPageNum] = useState(1);
  const [totalPages, setTotalPages] = useState(0);

  const fetchLogs = () => {
    setLoading(true);
    getTaskLogs(id, pageNum)
      .then((data) => {
        setLogs(data.task_logs.task_logs);
        setTotalPages(data.total_pages);
        setLoading(false);
      })
      .catch((err) => {
        console.log("error", err);
        setLoading(false);
      });
  };

  useEffect(() => {
    if (!show || !id) return;
    fetchLogs();
    const intervalId = setInterval(() => {
      fetchLogs();
    }, 8000);

    return () => clearInterval(intervalId);
  }, [pageNum, dateRange, logType, id]);

  return (
    <>
      <Modal show={show} fullscreen={true} onHide={() => setShow(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Logs</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="mx-4" style={{ marginTop: "50px" }}>
            {!logs && !loading && <h3>No logs found</h3>}
            <>
              <LogsScreen logs={logs} height="880px" from={"task"} />
              <Paginator
                pageNum={pageNum}
                setPageNum={setPageNum}
                totalPages={totalPages}
              />
            </>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default TaskLogsModal;
